import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy } from "lucide-react";
import { PortalShell } from "./PortalShell";
import { portalApi, portalErr } from "./portalApi";
import "../test/testTheme.css";

function ChallengeResultInner({ attemptId }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    portalApi.get(`/portal/challenge/result/${attemptId}`).then(({ data: d }) => setData(d)).catch((err) => setError(portalErr(err)));
  }, [attemptId]);

  if (error) return <div className="tp-wrap"><div className="tp-hero"><p className="tp-error" data-testid="challenge-result-error">{error}</p><Link className="tp-btn secondary" to="/portal/challenge">Back to challenge</Link></div></div>;
  if (!data) return <div className="tp-wrap"><div className="tp-hero"><p className="tp-muted">Loading your result…</p></div></div>;

  const r = data.attempt.result;
  return (
    <div className="tp-wrap" style={{ maxWidth: 880 }}>
      <section className="tp-score-hero">
        <div className="tp-eyebrow"><Trophy size={13} /> {(data.challenge?.title || "Weekly Challenge").toUpperCase()}</div>
        <div className="tp-score-big" data-testid="challenge-score">{r.score}/{r.max_score}</div>
        <p className="tp-muted">{r.correct}/5 correct · {r.accuracy}% accuracy · {Math.floor(r.time_taken_sec / 60)}m {String(r.time_taken_sec % 60).padStart(2, "0")}s</p>
        <p className="tp-note">Added to this month&apos;s leaderboard.</p>
      </section>
      <div style={{ textAlign: "center", margin: "8px 0 26px" }}><Link className="tp-btn secondary" to="/portal/challenge" data-testid="challenge-back-board">SEE THE LEADERBOARD</Link></div>
      <section style={{ paddingBottom: 40 }}>
        <h2 className="tp-h2">Answers & solutions</h2>
        <div className="tp-analysis" data-testid="challenge-analysis">
          {r.analysis.map((q, i) => (
            <div className="tp-analysis-card" key={q.question_id} data-testid={`challenge-analysis-${i}`}>
              <span className={`tp-pill ${q.status === "correct" ? "ok" : q.status === "incorrect" ? "bad" : ""}`}>{q.status === "correct" ? "CORRECT" : q.status === "incorrect" ? "INCORRECT" : "NOT ANSWERED"}</span>
              <h4>{q.text}</h4>
              <div className="tp-analysis-options">
                {["A", "B", "C", "D"].map((key) => <div key={key} className={key === q.correct_answer ? "correct" : key === q.selected ? "picked-wrong" : ""}><b>{key}.</b> {q.options[key]}</div>)}
              </div>
              <p className="tp-muted" style={{ fontSize: 12 }}>Your answer: <b>{q.selected ? `Option ${q.selected}` : "Not attempted"}</b> · Correct: <b>Option {q.correct_answer}</b></p>
              {q.explanation && <div className="tp-expl"><b>Explanation</b><br />{q.explanation}</div>}
              {q.solution && <div className="tp-expl"><b>Solution</b><br />{q.solution}</div>}
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default function PortalChallengeResult() {
  const { attemptId } = useParams();
  return <PortalShell><ChallengeResultInner attemptId={attemptId} /></PortalShell>;
}
